import { useContext } from 'react';

import { CookiesContext } from '../cookies';

export const useCookies = () => useContext(CookiesContext);
